import { Avatar, Box, Container, Link, Stack, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import systemIcon from '../assets/images/avatar-icon.svg';
import { errorMessage, unknownErrorMessage } from '../constants';

interface ContactAdminProps {
  error?: AxiosError; // app internal error
}

const ContactAdmin: FC<ContactAdminProps> = ({ error }) => {
  const { t } = useTranslation();

  const { search } = useLocation();
  const query = new URLSearchParams(search); // from api gateway

  // TODO: set error code from axios error
  const errorCode = query.get('code') ?? '';

  return (
    <>
      <Helmet>
        <title>{t('問題が発生しました')}</title>
      </Helmet>
      <Container
        maxWidth="lg"
        component="main"
        sx={{
          bgcolor: 'background.paper',
          color: 'text.primary',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pb: 10,
        }}
      >
        <Avatar src={systemIcon} sx={{ width: 80, height: 80 }} />
        <Stack spacing={0.5} mt={2} alignItems="center">
          <Typography>{errorCode in errorMessage ? t(errorMessage[errorCode]) : t(unknownErrorMessage)}</Typography>
          <Typography>{t('システム管理者にお問合せください')}</Typography>
        </Stack>
        <Box mt={3}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            component="button"
            underline="none"
            variant="body1"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            最初からやり直す
          </Link>
        </Box>
      </Container>
    </>
  );
};

ContactAdmin.defaultProps = {
  error: undefined,
};

export default ContactAdmin;
